<div class="container g-0 m-0 p-0">
  <div class="search-wrapper">
    <div class="select-box" role="button" [attr.tabindex]="disabled ? -1 : 0" [attr.aria-disabled]="disabled"
      [class.open]="isOpen" [class.disabled]="disabled" (click)="toggleDropdown()" (keydown.enter)="toggleDropdown()"
      (keydown.space)="$event.preventDefault(); toggleDropdown()">
      <span class="select-value">
        <ng-container *ngIf="selected; else emptySelection">
          <span class="item-details">
            <span class="item-name">{{ selected.asset ?? "/" }}</span> (<span class="item-name">{{
              selected.meterNumber ?? "/"
              }}</span>)
          </span>
        </ng-container>
        <ng-template #emptySelection>
          <span class="select-placeholder">{{ selectPlaceholder }}</span>
        </ng-template>
      </span>

      <span class="select-actions">
        <app-asset-type-badge *ngIf="selected" [assetType]="selected.assetType"
          [label]="selected.assetTypeName"></app-asset-type-badge>
        <button *ngIf="selected" type="button" class="clear-selected" (click)="clearSelected($event)"
          aria-label="Clear selected parent meter">
          <img alt="" src="assets/device/exit.svg" />
        </button>
        <span class="chevron" aria-hidden="true"></span>
      </span>
    </div>

    <div class="dropdown-panel" *ngIf="isOpen">
      <div class="search-input-box">
        <img alt="Magnifier" src="assets/device/magnifier2.svg" class="search-icon" />
        <input [disabled]="disabled" type="text" (ngModelChange)="search($event)" [(ngModel)]="searchText"
          placeholder="{{ placeholder | translate }}" />
      </div>

      <ul class="dropdown-list">
        <li class="dropdown-item" *ngFor="let item of filteredItems" (click)="selectItem(item)">
          <div class="item-details">
            <span class="item-name">{{ item.value?.asset ?? "/" }}</span> (<span class="item-name">{{
              item.value?.meterNumber ?? "/"
              }}</span>)
          </div>
          <app-asset-type-badge [assetType]="item.value?.assetType"
            [label]="item.value?.assetTypeName"></app-asset-type-badge>
        </li>
        <li class="dropdown-empty" *ngIf="filteredItems.length === 0">
          {{ "NORESULTS" | translate }}
        </li>
      </ul>
    </div>
  </div>
</div>
